import { Spinner } from "react-bootstrap";
import { useEffect, useState } from "react";
import { Input } from ".";
import styles from "./SwitchWithLoader.module.scss"

interface SwitchWithLoaderProps {
  isChecked: boolean;
  onChange: () => void;
}

const SwitchWithLoader: React.FC<SwitchWithLoaderProps> = ({ isChecked, onChange }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    setIsLoading(false);
  }, [isChecked]);

  const handler = async () => {
    setIsLoading(true);
    onChange();
    setIsLoading(false);
  };

  if (isLoading) {
    return (
      <Spinner
        size="sm"
        style={{ marginLeft: "10px", verticalAlign: "middle" }}
      />
    );
  }

  return (
    <label className={styles.switch}>
      <Input
        type="checkbox"
        checked={isChecked}
        disable={isLoading}
        onChange={handler}
      />
      <span className={`${styles.slider} ${styles.round}`}></span>
    </label>
  );
};

export default SwitchWithLoader;
